
import React, { useEffect, useReducer, useRef, useState } from 'react'
import styled from 'styled-components'
import { useTranslate } from '@tolgee/react';
import { ReactComponent as CloseIcon } from "../../Assets/iconsv2/generic/closeBtn.svg"
import PrimaryButton from '../GenericComponents/PrimaryButton';

const BlockedChatModal = ({ contact, handleUnblockContact, setShowBlockedChatModal }) => {

    const handleCloseModal = () => {
        setShowBlockedChatModal(false)
    }
    const { t } = useTranslate();
    return (
        <FullScreenItem>
            <RatingCard>
                <Line>
                    <ModalTitle>
                        <h1>{t('block_contacts.blocked_contact')} </h1>
                    </ModalTitle>
                    <CloseBtn onClick={() => handleCloseModal()}>
                        <CloseIcon />
                    </CloseBtn>
                </Line>

                <Group>
                    <SubtitleWrapper>
                        <p>{t('block_contacts.blocked_contact_modal_text')}</p>
                    </SubtitleWrapper>
                </Group>
                <Group>
                    <PrimaryButton
                        style={{ padding: "16px" }}
                        onClick={() => handleUnblockContact(contact)}
                        text={t('block_contacts.unblock').toUpperCase()}
                    />
                </Group>
            </RatingCard>
        </FullScreenItem >

    )
}

export default BlockedChatModal

const FullScreenItem = styled.div`
display:flex;
align-items:center;
justify-content:center;
position:absolute;
width:100%;
height:100%;
background:rgba(0,0,0,0.3);
left:0;
top:0;
z-index:1;
`
const RatingCard = styled.div`
display:flex;
flex-direction:column;
min-height:200px;
max-width:400px;
width:100%;
background:${({ theme }) => theme.menu.background};
border-radius:4px;
padding:30px;
align-items:center;
position:relative;


`

const Line = styled.div`
display:flex;
align-items:center;
width:100%;
`
const CloseBtn = styled.button`
position:absolute;
display:flex;
align-items:center;
background:none;
border:none;
cursor:pointer;
right:30px;
svg{
height:28px;
width:28px;
color:${({ theme }) => theme.menu.selectedOpionBackground};
stroke:${({ theme }) => theme.sidebar.borderColor};
}
`
const Group = styled.div`
display:flex;
flex-direction:column;
gap:25px;
width:100%;
`

const SubtitleWrapper = styled.div`
display: flex;
justify-content: space-between;
margin:20px 0;
p {
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;

}
`

const ModalTitle = styled.div`
display: flex;
margin-left:auto;
margin-right:auto;
    h1{
        font-size:20px;
        line-height:24px;
        font-weight:600;
  color: ${({ theme }) => theme.menu.primaryTextColor};
    }

`